var _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWsbLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "#92C01A",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102.5 70.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "90.7,0 86.1,0 82.6,0 42.1,0 32.9,0 30.4,0 30.4,30.3 48.8,40.9 48.8,58.1 30.4,47.4 11.7,58.1 11.7,0  0,0 0,70.7 11.7,70.7 30.3,60.1 48.8,70.7 60.6,70.7 60.6,34.5 42.1,23.9 42.1,11.7 82.6,11.7 86.1,11.7 90.7,11.7 90.7,19.8  83.4,24.1 83.4,36.3 90.7,40.5 90.7,59 77.6,59 77.6,17.4 65.8,17.4 65.8,59 65.8,70.7 77.6,70.7 90.7,70.7 102.5,70.7 102.5,59  102.5,34.4 94.9,30 102.5,25.7 102.5,11.7 102.5,0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsbLogo);
export default __webpack_public_path__ + "static/media/wsb_logo.bd46b8230a1332fe82d2767ba380fd8e.svg";
export { ForwardRef as ReactComponent };